<template>
  <div v-if="displayableOptions?.length" class="wc-payment-badges">
    <WCPaymentOptionBadgeModernCard
      v-for="paymentOption in displayableOptions"
      :key="paymentOption.id"
      :paymentOption="paymentOption"
    />
  </div>
</template>

<script setup lang="ts">
import { defineProps, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { PAYMENT_METHOD_TYPES } from '@/constants/AppConstants';
import ItemDetail from '@/models/entities/items/item-detail';
import WebPaymentMethod from '@/models/entities/items/web-payment-method';
import WCPaymentOptionBadgeModernCard from '../WCPaymentOptionBadgeModernCard/WCPaymentOptionBadgeModernCard.vue';

const props = defineProps<{
  item: ItemDetail;
  ebtOnly?: boolean;
}>();

const { t } = useI18n();

const getTenderLabel = (specialTender: WebPaymentMethod): string => {
  if (specialTender.tenderType === PAYMENT_METHOD_TYPES.EBT_SNAP) {
    return t('ebtSnap');
  }
  if (specialTender.tenderType === PAYMENT_METHOD_TYPES.EBT_CASH_BENEFITS) {
    return t('ebtCashLabel');
  }
  return specialTender.name || '';
};

const displayableOptions = computed(() => {
  let specialTenders = props.item.specialTenders;
  if (props.ebtOnly) {
    specialTenders = specialTenders?.filter(
      specialTender =>
        specialTender.tenderType === PAYMENT_METHOD_TYPES.EBT_SNAP ||
        specialTender.tenderType === PAYMENT_METHOD_TYPES.EBT_CASH_BENEFITS,
    );
  }
  return specialTenders
    ?.map(specialTender => ({ ...specialTender, label: getTenderLabel(specialTender) }))
    .sort((a, b) => (a.label ?? '').localeCompare(b.label ?? ''));
});
</script>

<style scoped lang="scss">
.wc-payment-badges {
  margin-top: 1rem;
  margin-bottom: 0.25rem;
  padding: 0 0.5rem 0.25rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  background: transparent;
  border-top: none;
  height: auto;
  max-height: 3.75rem;
  overflow: hidden;
}
</style>
